import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteAPI, getAPI, postAPI, putAPI } from "../../service/http-service";
import { CourseInstructorEndpoint } from "../../service/endpointConfig/CourseInstructorEndpoint";

export interface forgetPassword {
  id: string;
  createdDate: any;
  updatedDate: any;
  lastUpdatedBy: any;
  franchiseeId: any;
  courseInstructorName: any;
  mobileNumber: any;
  whatsappMobileNumber: any;
  email: any;
  dateOfBirth: any;
  gender: any;
  active: any;
  ciCode: any;
  ciLastLevelTrained: any;
  numberOfStudents: any;
}

let initialState: any = {
  courseInstructorResponse: {},
};

//Get Course Instructor API call
export const courseInstructorAction = createAsyncThunk(
  "master/courseInstructor",
  async (ciData: any) => {
    try {
      let response;
      switch (ciData.apiAction) {
        case "list":
          response = await getAPI(CourseInstructorEndpoint.courseInstructor);
          break;
        case "listById":
          response = await getAPI(
            `${CourseInstructorEndpoint.courseInstructor}/${ciData.formValues}`
          );
          break;
        case "viewById":
          response = await getAPI(
            `${CourseInstructorEndpoint.viewcourseInstructor}/${ciData.formValues}`
          );
          break;
        case "isExist":
          response = await getAPI(
            `${CourseInstructorEndpoint.isExists}/${ciData.requestParam}`
          );
          break;
        case "create":
          response = await postAPI(
            CourseInstructorEndpoint.courseInstructor,
            ciData.formValues
          );
          break;
        case "update":
          response = await putAPI(
            CourseInstructorEndpoint.courseInstructor,
            ciData.formValues
          );
          break;
        case "delete":
          response = await deleteAPI(
            `${CourseInstructorEndpoint.courseInstructor}/${ciData.formValues}`
          );
          break;
        case "deleteAll":
          response = await deleteAPI(
            `${CourseInstructorEndpoint.courseInstructor}?${ciData.requestParams}`
          );
          break;
        case "exportExcel":
          response = await postAPI(
            CourseInstructorEndpoint.courseInstructorExportExcel,
            ciData.formValues
          );
          break;
      }

      return response;
    } catch (err) {
      return err;
    }
  }
);

const courseInstructorSlice = createSlice({
  name: "courseInstructor",
  initialState,
  reducers: {
    addObj: (state, action: any) => {
      state.entity.push({ success: false });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(courseInstructorAction.fulfilled, (state, action) => {
      state.courseInstructorResponse = action.payload;
    });
    builder.addCase(courseInstructorAction.rejected, (state, action) => {
      if (action.payload) {
        state.entity = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
  },
});

const courseInstructorReducer = courseInstructorSlice.reducer;
export default courseInstructorReducer;
